import React from 'react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

const MobileStickyBar = ({
  price,
  priceLabel,
  ctaLabel,
  onCtaClick,
  ctaType = 'button',
  disabled = false,
  loading = false,
  secondaryAction,
  className,
  children,
}) => {
  return (
    <div
      className={cn(
        'fixed bottom-0 inset-x-0 z-40 lg:hidden border-t border-gray-200 bg-white/95 backdrop-blur-sm shadow-[0_-4px_16px_rgba(0,0,0,0.06)] pb-safe px-4 pt-3',
        className
      )}
    >
      <div className="flex items-center gap-3 max-w-7xl mx-auto">
        {price != null && (
          <div className="flex-shrink-0 min-w-0">
            {priceLabel && <p className="text-xs text-gray-500">{priceLabel}</p>}
            <p className="text-lg font-semibold text-gray-900">{price}</p>
          </div>
        )}
        <div className="flex min-w-0 flex-1 items-center gap-2">
          <Button
            type={ctaType}
            size="lg"
            className="min-h-[44px] flex-1 bg-black hover:bg-gray-800"
            onClick={onCtaClick}
            disabled={disabled || loading}
          >
            {loading ? 'Yükleniyor...' : ctaLabel}
          </Button>
          {secondaryAction && (
            <Button
              type="button"
              variant="outline"
              size="icon"
              className="h-11 w-11 shrink-0"
              onClick={secondaryAction.onClick}
              aria-label={secondaryAction.ariaLabel}
            >
              {secondaryAction.icon}
            </Button>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default MobileStickyBar;
